// extracted by mini-css-extract-plugin
module.exports = {"loadingMask":"loading_loadingMask__1Fqrm","svg":"loading_svg__2Fjhu"};